<template>
  <!-- 明细弹窗 -->
  <div>
    <Modal v-model="visible" title="提现结算单" :mask-closable="false" width="1200px" class="my-modal" :footer-hide="true">
      <Table :columns="columns" :data="tableDate" @on-selection-change="tableSelect">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="lookDetail(row)">明细</span>
        </template>
      </Table>
      <div class="ivu-modal-footer" v-if="this.tabId == 1 && $units.pointAction('offline_81_8_btn6')">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">确认打款</Button>
      </div>
    </Modal>
    <!-- 短信验证 -->
    <update-invoice ref="updateInvoiceRef" @reload="reload" />
  </div>
</template>
<script>
import updateInvoice from './updateInvoice';
import { common } from '@/api/mixins';
import { config } from './withdrawalList.config.js';
export default {
  components: {
    updateInvoice
  },
  mixins: [common, config],
  data() {
    return {
      visible: false,
      tabId: '',
      columns: [],
      tableDate: [],
      tableItem: {}, // 外部表格数据
      searchParams: {}, // 外部查询数据
      selectArr: []
    };
  },
  computed: {},
  activated() {
    console.log('activated', this.visible);
    if (this.visible) {
      this.getList();
    }
  },
  methods: {
    // 打开弹窗
    open(data, searchParams, tabId) {
      this.visible = true;
      this.tableItem = data;
      this.tabId = tabId;
      this.searchParams = searchParams;
      this.selectArr = [];
      this.getColumns();
      this.getList();
    },
    getList() {
      const params = {
        userId: this.tableItem.userId,
        id: this.tableItem.id,
        reportIds: this.tableItem.reportIds
      };
      if (this.tabId == 1) {
        params.okbStatus = -2;
      } else if (this.tabId == 3) {
        params.okbStatus = -1;
      }
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkbDetailList',
        type: 'POST',
        data: params
      }).then(res => {
        res.data.forEach(item => {
          // item._checked = true;
          if ([-1, 3].includes(this.tableItem.okbStatus * 1)) {
            this.selectArr.push(item);
          }
        });
        this.tableDate = res.data;
      });
    },
    // 操作完成刷新
    reload() {
      this.$emit('reload');
      this.visible = false;
    },
    // 选择表格数据
    tableSelect(selection) {
      this.selectArr = selection;
    },
    // 查看明细
    lookDetail(row) {
      if (row.issueType == 3) {
        // 风险单
        this.openPageTabTags('/financialManage/riskOrderOK/riskOrderList', {
          riskPolicyIds: row.riskPolicyIds.join(',') || '',
          backUrl: this.delQueStr(this.$route.fullPath, 'time')
        });
      } else {
        this.openPageTabTags('/financialManage/salesmanPaySettlement/detail/formRiskOrderOK', {
          reportId: row.reportId,
          tabVal: 1,
          userId: row.userId,
          hideBtn: this.tabId == 3 ? 1 : 0,
          pageType: 'riskOrderOK'
        });
      }
    },
    // 提交
    submit() {
      if (this.selectArr.length == 0) {
        this.$notice.error('请选择至少一个结算单');
        return;
      }
      const params = {
        userIds: [this.tableItem.userId],
        operationType: 1,
        reportIds: [],
        policyNo: [],
        commissionPrice: 0
      };
      this.selectArr.forEach(item => {
        params.reportIds.push(item.reportId);
        params.policyNo.push(`${item.reportName}`);
        // 打款金额等于 税后合计 减去 风险单金额
        params.commissionPrice = Number(params.commissionPrice).add(Number(item.netIncome)).sub(Number(item.riskAmount));
      });
      params.policyNo = params.policyNo.join(', ');
      this.$refs.updateInvoiceRef.open(params, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
}
</style>
